module.exports = __webpack_public_path__ + "img/Wijs.56fe59b4.png";